import {Container} from "bounce-ui/backoffice";
import React from "react";
import {KeyValueRow} from "../Components";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {DATE_FORMAT, DATE_FORMAT_V2} from "@bounce/shared/helpers";

interface IPlanStartDate {
  field: string;
  startDate: string;
  setStartDate: (date: string) => void;
  endDate: string;
  minDate?: string;
  maxDate?: boolean;
}

export const PlanStartDate = ({field, startDate, setStartDate, endDate, minDate, maxDate}: IPlanStartDate) => {
  const onChangeDate = (event: any) => {
    setStartDate(dayjs(event).format(DATE_FORMAT));
  };

  return (
    <KeyValueRow field={field}>
      <Container row>
        starts on{" "}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={dayjs(startDate)}
            onChange={onChangeDate}
            minDate={minDate ? dayjs(minDate).add(1, "day") : null}
            maxDate={maxDate ? dayjs().add(30, "day") : null}
            format="MMM DD, YYYY"
            sx={{
              width: "160px",
              height: "34px",
              "& input": {
                height: "30px",
                padding: "0px 0px 0px 6px",
              },
            }}
          />
        </LocalizationProvider>
        ends {dayjs(endDate).format(DATE_FORMAT_V2)}
      </Container>
    </KeyValueRow>
  );
};
